export const isObject = (x: any): boolean =>
  typeof x === 'object' && !Array.isArray(x) && x !== null;
